import React from 'react'
import { HorizontalTicker } from 'react-infinite-ticker'

const customers = [
   {
      name: 'Government of Alberta',
      image: 'alberta.png'
   },
   {
      name: 'Westjet',
      image: 'westjet.png'
   },
   {
      name: 'Shell',
      image: 'shell.png'
   },
   {
      name: 'Solarwinds',
      image: 'solarwinds.png'
   },
   {
      name: 'Suncor',
      image: 'suncor.png'
   },
   {
      name: 'Imperial',
      image: 'imperial.png'
   },
   {
      name: 'Government of Canada',
      image: 'canada.png'
   },
   {
      name: 'Total',
      image: 'total.png'
   },
   {
      name: "Alberta Teacher's Association",
      image: 'ata.png'
   },
   {
      name: 'ConocoPhillips',
      image: 'conoco.png'
   }
]

const LogoBlock = () => {
   return (
      <div className="relative w-full md:bg-black overflow-hidden py-8">
         <div className="text-white/50 text-balance text-xs uppercase tracking-wider md:mb-8 text-center px-12 pt-8">
            Communities is trusted by companies and organizations worldwide
         </div>
         <HorizontalTicker duration={100000}>
            {customers.map(customer => (
               <div
                  key={customer.name}
                  className="flex items-center justify-center w-28 h-24 py-[28px] mx-8 sm:mx-12">
                  <div className="w-full h-full">
                     <img
                        src={`/assets/custom/communities/images/logos/${customer.image}`}
                        alt={customer.name}
                        className="w-full h-full object-contain opacity-70"
                     />
                  </div>
               </div>
            ))}
            {customers.map(customer => (
               <div
                  key={`${customer.name}-clone`}
                  className="flex items-center justify-center w-28 h-24 py-[28px] mx-8 sm:mx-12">
                  <div className="w-full h-full">
                     <img
                        src={`/assets/custom/communities/images/logos/${customer.image}`}
                        alt={customer.name}
                        className="w-full h-full object-contain opacity-70"
                     />
                  </div>
               </div>
            ))}
         </HorizontalTicker>
         <div className="absolute w-40 inset-0 bg-gradient-to-r from-black md:from-black to-transparent hidden sm:block" />
         <div className="absolute top-0 bottom-0 right-0 w-40 bg-gradient-to-r from-transparent to-black md:to-black hidden sm:block" />
      </div>
   )
}

export default LogoBlock
